import constate from "constate";
import { useRef, useState, useEffect } from "react";
import { TableDataBuffer } from "../utils/buffer/TableDataBuffer.js";
import { FetchStatus } from "../utils/buffer/types.js";
const useDataBuffer = ({
  onLoadRows,
  onUpdateRows
}) => {
  const buffer = useRef(new TableDataBuffer());
  const initLoadQueue = useRef();
  const [fetchStatus, setFetchStatus] = useState(
    FetchStatus.loading
  );
  const incrementLoadQueue = () => {
    initLoadQueue.current = (initLoadQueue.current || 0) + 1;
  };
  const decrementLoadQueue = () => {
    if (initLoadQueue.current && typeof initLoadQueue.current === "number" && initLoadQueue.current > 0) {
      initLoadQueue.current = initLoadQueue.current - 1;
    }
  };
  useEffect(() => {
    buffer.current.onDataLoad = onLoadRows;
    buffer.current.onDataUpdate = onUpdateRows;
  }, [onLoadRows, onUpdateRows]);
  const initLoad = async () => {
    buffer.current.onDataLoad = onLoadRows;
    buffer.current.onDataUpdate = onUpdateRows;
    buffer.current.setDataLoadCallbacks({
      onDataLoadStart: () => setFetchStatus(FetchStatus.loading),
      onDataLoadSuccess: () => setFetchStatus(FetchStatus.success),
      onDataLoadError: () => setFetchStatus(FetchStatus.failed)
    });
    incrementLoadQueue();
    await buffer.current.loadPages();
    decrementLoadQueue();
    if (initLoadQueue.current === 0) {
      buffer.current.setDataLoadCallbacks({});
    }
  };
  return {
    buffer: buffer.current,
    onUpdateRows,
    onLoadRows,
    initLoad,
    isLoading: fetchStatus === FetchStatus.loading,
    isErrored: fetchStatus === FetchStatus.failed,
    isComplete: fetchStatus === FetchStatus.success
  };
};
const [DataBufferProvider, useDataBufferContext] = constate(useDataBuffer);
export {
  DataBufferProvider,
  useDataBufferContext
};
